<template>
    <div class="account">
        <br>
        <el-form :inline="true" :model="formInline" :class="{elform:active}">
            <el-form-item label=" 出库日期:">
                <el-date-picker v-model="chartTimeValue"
                                :clearable="false"
                                type="daterange" align="center" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions2">
                </el-date-picker>
            </el-form-item>
            <el-input style="width: 150px" placeholder="出库单号" v-model="inputvalue" clearable></el-input>
            <el-form-item>
                <el-button type="primary" class="el-icon-search" @click="onSubmit"></el-button>
            </el-form-item>
        </el-form>

        <el-table border :data="tableData" style="width: 98%;margin-left: 18px" :header-cell-style="tableHeaderColor">
            <el-table-column prop="saleOrderNo" label="出库单号"></el-table-column>
            <el-table-column prop="saleDate" label="出库日期"></el-table-column>
            <el-table-column prop="saleName" label="出库人"></el-table-column>
            <el-table-column  label="操作" width="280">
                <template scope="scope">
                    <el-button type="text" size="small" @click="check(scope.row)">查看详情</el-button>
                    <!--<el-button type="text" size="small">编辑</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync=Current
                    :page-size="this.Size"
                    layout="total,prev, pager, next, jumper"
                    :total="this.total">
            </el-pagination>
        </div>
    </div>
</template>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .account {
        width: 99%;
        padding-bottom: 50px;
        background-color: white;
    }

    .block {
        margin-top: 20px;
        padding-left: 33%;
    }

    .el-table .warning-row {
        background: #ffaaa3;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    el-input {
        width: 100px;
    }

    .stylecolor {
        color: red;
    }

    .elform {
       float: right;
        margin-right: 10px;
        padding-left: 20px;
    }

</style>

<script>
  import {formatDate} from "../../common/date";

  export default {

    username: 'account',
    data() {
      return {
        Current: 1,
        Size: 10,
        data: {},
        currentPage: 1,
        total: 0,
        tableData: [],
        currentPage1: 3,
        value1: '采购入库',
        inputvalue: '',
        chartTimeValue: [Date.now() - 8.64e7 * 7, Date.now()],
        leftNum: 900,
        active: true,
        formInline: {
          user: '',
          region: '',
          account: '',
        },
        pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },

      }
    },

    //实例化就获取数据
    mounted: function () {
      this.data = {
        startDate: formatDate(this.chartTimeValue[0], 'yyyy-MM-dd'),
        endDate: formatDate(this.chartTimeValue[1], 'yyyy-MM-dd'),
        saleId: this.inputvalue
      }
      this.getinfo();
    },

    methods: {
      tableHeaderColor({row, column, rowIndex, columnIndex}) {
        if (rowIndex === 0) {
          return "background-color:#f2f2f2;color: #a4a7af;";
        }
      },
      getinfo: function () {
        this.$axios({
          url: '/api/medicine/sale/pageNumber/ ' + this.Current + '/size/' + this.Size,
          method: 'POST',
          data: this.data
        }).then(res => {
          this.total = res.data.data.totalElements;
          this.tableData = res.data.data.content;
        }).catch(err => {
          console.log(err.data);
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.Size = val;
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.Current = val;
        this.getinfo();
      },
      onSubmit: function () {
          let n = /^[0-9]*$/;
          if (n.test(this.inputvalue)) {
              console.log(n.test(this.inputvalue));
          } else {
              this.$message({
                  type: "danger",
                  message: '出库单号格式不正确'
              })
              return
          }
          this.Current=1;
        this.data.startDate = formatDate(this.chartTimeValue[0], 'yyyy-MM-dd');
        this.data.endDate = formatDate(this.chartTimeValue[1], 'yyyy-MM-dd');
        this.data.saleId = this.inputvalue;
        this.getinfo();
      },
      check(row) {
        console.log(row);
        let saleOrderNo = row.saleOrderNo;
        this.$router.push({path: "./checkout", query: {saleOrderNo: saleOrderNo}})
      },
    },
  }

</script>




// WEBPACK FOOTER //
// outHouse.vue?ed5bfffc